import { render } from "./TodaysSales.vue?vue&type=template&id=0defc8ba&scoped=true"
import script from "./TodaysSales.vue?vue&type=script&lang=js"
export * from "./TodaysSales.vue?vue&type=script&lang=js"

import "./TodaysSales.vue?vue&type=style&index=0&id=0defc8ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0defc8ba"

export default script